<template>
  <div class="p-m-3 sp-page">
    <MockBanner>These are the business choices for MBP to make. Each one is a setting with the recommended choice first, so it can be changed later
      without new work.</MockBanner>
    <h2>Sites &amp; Projects settings</h2>
    <p class="sp-sub">Admin only. Would sit under SETTINGS next to Warnings &amp; Approvals.</p>

    <div class="p-card p-p-4" style="max-width: 900px;">
      <div v-for="s in items" :key="s.key" class="sp-setting">
        <div class="sp-setting-head">
          <span class="sp-chip grey-chip">{{ s.ref }}</span>
          <strong>{{ s.title }}</strong>
        </div>
        <div class="sp-muted" style="margin: 4px 0 8px 0;">{{ s.help }}</div>
        <div v-if="!s.multi" class="sp-row">
          <div v-for="(o, i) in s.options" :key="o.value" class="p-field-radiobutton" style="margin: 0;">
            <RadioButton :id="s.key + o.value" :name="s.key" :value="o.value" v-model="values[s.key]" />
            <label :for="s.key + o.value">{{ o.label }}<span v-if="i === 0" class="sp-muted"> (recommended)</span></label>
          </div>
        </div>
        <div v-else class="sp-row">
          <div v-for="o in s.options" :key="o.value" class="p-field-checkbox" style="margin: 0;">
            <Checkbox :id="s.key + o.value" :value="o.value" v-model="values[s.key]" />
            <label :for="s.key + o.value">{{ o.label }}</label>
          </div>
        </div>
        <div v-if="s.example" class="sp-note grey" style="margin-top: 8px;"><i class="pi pi-calculator"></i><span>{{ s.example }}</span></div>
      </div>
      <div class="sp-row" style="justify-content: flex-end;">
        <Button label="Save" icon="pi pi-check" class="p-button-success" style="width: 110px;" disabled />
      </div>
    </div>
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'

export default {
  name: 'SpSitesProjectsSettings',
  components: { MockBanner },
  data() {
    return {
      values: {
        valueRule: 'average', s2Counts: 'latest', s2Warn: ['branchManagers', 'salesDirector'], projectRequired: 'optional',
        countRoles: 'all', createSites: 'everyone', mergeProjects: 'managers'
      },
      items: [
        {
          key: 'valueRule', ref: 'SP3', title: 'Which value counts while a job is tendered',
          help: 'For one project and product type quoted to several contractors. Once won, the won value counts.',
          options: [{ value: 'average', label: 'Average' }, { value: 'highest', label: 'Highest' }, { value: 'lowest', label: 'Lowest' }],
          example: 'Doorsets quoted at £90,000 and £100,000: Average £95,000 · Highest £100,000 · Lowest £90,000.'
        },
        {
          key: 's2Counts', ref: 'SP4', title: 'Same customer quoted twice on a project (two branches): which one counts',
          help: 'Both enquiries are kept and marked as a duplicate pair; only one counts in the quote bank.',
          options: [{ value: 'latest', label: 'The latest' }, { value: 'highest', label: 'The highest' }, { value: 'first', label: 'The first entered' }],
          example: 'Carter Lauren, Premier Inn Littlehampton: MIDLANDS £163,314 (15/01/2026) and DOORSETS £56,676 (07/09/2026). Latest counts £56,676; highest counts £163,314.'
        },
        {
          key: 's2Warn', ref: 'SP4', title: 'Who gets the duplicate email', multi: true,
          help: 'Sent when a user carries on past the duplicate warning. Uses the Warnings & Approvals email.',
          options: [{ value: 'branchManagers', label: 'Branch managers of both branches' }, { value: 'salesDirector', label: 'Sales Director' }, { value: 'admin', label: 'Admin' }]
        },
        {
          key: 'projectRequired', ref: 'SP6', title: 'Project on new enquiries',
          help: 'Decided 06/10: optional. The form offers "No project" for spare parts and small orders.',
          options: [{ value: 'optional', label: 'Optional ("No project" allowed)' }, { value: 'required', label: 'Required' }, { value: 'tenders', label: 'Required for tenders only' }]
        },
        {
          key: 'countRoles', ref: 'SP5', title: 'Which customer roles count in the project value',
          help: 'Main contractor and sub-contractor quotes for the same job and product type.',
          options: [{ value: 'all', label: 'All contractors' }, { value: 'main', label: 'Main contractors only (if any)' }],
          example: 'Main contractor £100,000, sub-contractor £90,000: All → £95,000 · Main only → £100,000.'
        },
        {
          key: 'createSites', ref: 'SP10', title: 'Who can add Sites and Projects',
          help: 'Adding is part of entering an enquiry, so it should not be blocked.',
          options: [{ value: 'everyone', label: 'Everyone who can add enquiries' }, { value: 'managers', label: 'Managers and Admin only' }]
        },
        {
          key: 'mergeProjects', ref: 'SP10', title: 'Who can merge duplicate Projects and Sites',
          help: 'Merging moves every enquiry to the kept record.',
          options: [{ value: 'managers', label: 'Managers and Admin' }, { value: 'admin', label: 'Admin only' }]
        }
      ]
    }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
.sp-setting { border-bottom: 1px solid #eee; padding: 12px 0; }
.sp-setting-head { display: flex; gap: 8px; align-items: center; }
.grey-chip { background: #eceff1; color: #37474f; }
</style>
